import { Injectable } from "@angular/core";

import { ChargetypesService } from "./chargetypes.service";

@Injectable({ providedIn: "root" })
export class ChargeTypesResolver {
  constructor(private chargeTypesService: ChargetypesService) {}

  resolve() {
    return this.chargeTypesService.listDropDown();
  }
}
